import { Button, Divider, Row, Col, Space, Typography } from 'antd';
import React, { FC, useState } from 'react';
import HippySvg from './image/hippy.svg';
import KuiklySvg from './image/kuikly.svg';
import TdfHomeLogo from './image/tdf-home.svg';
import TdsHomeActiveLogo from './image/tds-home-active.svg';
import TdsHomeLogo from './image/tds-home.svg';
import TdsLiteHoverLogo from './image/tds-lite-hover.svg';
import TdsLiteLogo from './image/tds-lite.svg';
import TdsQQHomeLogo from './image/tds-qq-home.svg';
import TdsQQLiteLogo from './image/tds-qq-lite.svg';
import VectorLayoutSvg from './image/vectorLayout.svg';
import './index.scss';
import { locales } from './locale';
import { useTranslation } from 'react-i18next';
import i18n from '@/i18n';

type Lang = 'ZH_CN' | 'EN';

interface BaseProps {
  locale?: Lang
}

interface FooterProps extends BaseProps {
  qrcode?: string; // 二维码
  tdsLogo?: string;
  privacyPolicyUrl?: string;
  hasChildrenLogo?: boolean;
  // 是否展示产品矩阵
  showMatrixList?: boolean;
  // 备案号
  icp?: string;
  icpURL?: string;
  isTdf?: boolean;
  copyRight?: string;
  showPcgTerm?: boolean;
  serviceTermUrl?: string;
  cookiePolicyUrl?: string;
}

interface FooterLiteProps extends BaseProps {
  privacyPolicyUrl?: string;
  // 是否是商业化
  isTdsQQ?: boolean;
  copyRight?: string;
  serviceTermUrl?: string;
  cookiePolicyUrl?: string;
}
const platformList = [
  {
    title: i18n.t('Bugly监控定位'),
    src: 'https://bugly.woa.com/v2/index/main',
  },
  {
    title: i18n.t('智能低代码'),
    src: 'https://xy.woa.com/xy/app/prod/portal/index',
  },
  {
    title: i18n.t('TDF端框架'),
    src: 'https://tdf.woa.com',
  },
  {
    title: i18n.t('Shiply容器与发布'),
    src: 'https://shiply.tds.woa.com/',
  },
  {
    title: i18n.t('Rightly应用合规'),
    src: 'https://docs.bugly.woa.com/rightly/rightly_intro',
  },
  {
    title: i18n.t('RAFT组件市场'),
    src: 'https://raftx.woa.com/',
  },
  {
    title: 'More >>',
    src: 'https://tds-home.woa.com/v1',
  },
];
const tdsqqPlatformList = [
  {
    title: i18n.t('Bugly监控定位'),
    src: 'https://bugly.tds.qq.com/v2/index/tds-main',
  },
  {
    title: i18n.t('智能低代码'),
    src: 'https://wujicode.cn/xy/app/prod/official/index',
  },
  {
    title: i18n.t('TDF跨平台框架'),
    src: 'https://internal-test-2.wujicode.cn/page/homepage',
  },
  {
    title: i18n.t('Shiply容器与发布'),
    src: 'https://shiply.tds.qq.com/',
  },
  {
    title: i18n.t('Rightly应用合规'),
    src: 'https://rightly.tds.qq.com',
  },
];
const DEFAULT_ICP = '粤B2-20090059';
const DEFAULT_ICP_URL = 'https://beian.miit.gov.cn/#/Integrated/index';
const TDS_HOME_URL = 'https://tds-home.woa.com/v1';
const TDS_QQHOME_URL = 'https://tds.qq.com';
const handleOpenUrl = (src: string) => {
  if (src) {
    window.open(src);
  }
};

export const SgpFooter: FC<{
  /**
   * @description icp
   * @default 粤B2-20090059
   */
  icp?: string;
  /**
   * @description icpURL
   * @default https://beian.miit.gov.cn/#/Integrated/index
   */
  icpURL?: string;
  /**
   * @description 是否是tdf页面
   * @default false
   */
  isTdf?: boolean;
  /**
   * @description 隐私保护声明url
   * @default https://privacy.qq.com/document/preview/ca7228b56e6941638fc755edb1a497a7
   */
  privacyPolicyUrl?: string;
  copyRight?: string;
  locale?: Lang;
}> = (props) => {
  const { t } = useTranslation();
  const { icp = DEFAULT_ICP, icpURL = DEFAULT_ICP_URL, isTdf, locale = 'ZH_CN' } = props;
  const [active, setActive] = useState(false);
  const localeWording = locales[locale];
  const icpOnClick = () => {
    if (!icpURL) {
      return;
    }
    const a = document.createElement('a');
    a.href = icpURL;
    a.target = '_blank';
    a.click();
  };
  let homeSvg = TdsHomeLogo;
  if (active) {
    homeSvg = TdsHomeActiveLogo;
  }
  if (isTdf) {
    homeSvg = TdfHomeLogo;
  }

  return (
    <div className='tds-footer'>
      <div className='home-footer'>
        <Space align='center' size={28}>
          <img
            src={homeSvg}
            alt=""
            className={'home-footer-logo'}
            onClick={() => handleOpenUrl(TDS_HOME_URL)}
            onMouseEnter={() => setActive(true)}
            onMouseLeave={() => setActive(false)}
          />
          {
            isTdf ? (
              <Space size={14} align='center' className='tdf-icon'>
                <Space size={5} align='center'>
                  <img src={HippySvg} alt="" />
                  <span>Hippy</span>
                </Space>
                <Space size={5} align='center'>
                  <img src={KuiklySvg} alt="" style={{ width: '24px' }} />
                  <span>Kuikly</span>
                </Space>
                <Space size={5} align='center'>
                  <img src={VectorLayoutSvg} alt="" />
                  <span>VectorLayout</span>
                </Space>
              </Space>
            ) : null
          }
        </Space>
        <br />
        <Space className='platform' align='center'>
          <span className='platform-title'>{t("端服务产品：")}</span>
          <Row gutter={20}>
            {platformList.map((item, idx) => (
              <Col key={idx}>
                <Button type='link' className='platform-btn tds-btn' onClick={() => (handleOpenUrl(item.src))}>{item.title}</Button>
              </Col>
            ))}
          </Row>
        </Space>
        <Divider style={{ margin: '20px 0', background: '#4B4B4B' }} />
        <Space size={11} className='home-footer-copyright' align="center">
          <span>{localeWording.copyright}</span>
          <Space size={0}>
            <Button type='link' className='tds-btn tds-btn-link' onClick={() => (window.open('https://www.qq.com/contract.shtml'))}>{localeWording.serviceTerm}</Button>
            <Divider type='vertical' className='divider' />
            <Button type='link' className='tds-btn tds-btn-link' onClick={() => (window.open(props?.privacyPolicyUrl || 'https://privacy.qq.com/policy/tencent-privacypolicy'))}>{localeWording.privacy}</Button>
          </Space>
          <div className='footer-ccg-text'>{t("腾讯公司")}<span className='index-footer-pcg-divider'>{t("版权所有")}</span>
            <span className='footer-pcg-href' onClick={icpOnClick}>
              <span className='index-footer-pcg-divider'>{t("主体备案号")}</span><span className='icp'>{icp}</span>
            </span>
          </div>
        </Space>
      </div>
    </div>
  );
};

// 内页页脚
export const SgpFooterLite: FC<FooterLiteProps> = (props) => {
  const { t } = useTranslation();
  const { isTdsQQ, locale = 'ZH_CN' } = props;
  const [active, setActive] = useState(false);
  const localeWording = locales[locale];
  let homeSvg = TdsLiteLogo;
  if (active) {
    homeSvg = TdsLiteHoverLogo;
  }
  if (isTdsQQ) {
    homeSvg = TdsQQLiteLogo;
  }

  if (locale === 'EN') {
    return (
      <div className='tds-footer-lite'>
        <Space split={<Divider type="vertical" />}>
          <span>{localeWording.copyright}</span>
          <Button type='link' onClick={() => window.open(props?.privacyPolicyUrl || 'https://privacy.qq.com/document/preview/ca7228b56e6941638fc755edb1a497a7')} className='privacy tds-btn'>{localeWording.privacy}</Button>
          <Button type='link' onClick={() => window.open(props?.serviceTermUrl || 'https://privacy.qq.com/document/preview/ca7228b56e6941638fc755edb1a497a7')} className='privacy tds-btn'>{localeWording.serviceTerm}</Button>
          <Button type='link' onClick={() => window.open(props?.cookiePolicyUrl || 'https://privacy.qq.com/document/preview/ca7228b56e6941638fc755edb1a497a7')} className='privacy tds-btn'>{localeWording.cookiePolicy}</Button>
        </Space>
      </div>
    );
  }

  return (
    <div className='tds-footer-lite'>
      <Space split={<Divider type="vertical" />}>
        <Button className='copyright tds-btn' type="link">
          {t("腾讯公司")}
          <span className='copyright-txt'>{t("版权所有")}</span>
          <span className='footer-pcg-divider'>
            <img
              src={homeSvg}
              onClick={() => handleOpenUrl(isTdsQQ ? '' : TDS_HOME_URL)}
              onMouseEnter={() => setActive(true)}
              onMouseLeave={() => setActive(false)}
            />
          </span>
          <span className='footer-pcg-divider'>{localeWording.copyright}</span>
        </Button>
        <Button type='link' onClick={() => window.open(props?.privacyPolicyUrl || 'https://privacy.qq.com/document/preview/ca7228b56e6941638fc755edb1a497a7')} className='privacy tds-btn'>{t("隐私政策")}</Button>
      </Space>
      <div className='pag-matrix'>
      <span style={{ lineHeight: '36px' }}>{t("端服务产品：")}</span>
        {(isTdsQQ ? tdsqqPlatformList : platformList).map((item, idx) => (
          <Button key={idx} type='link' className='platform-btn tds-btn' onClick={() => (handleOpenUrl(item.src))}>{item.title}</Button>
        ))}
      </div>
    </div>
  );
};

// 商业化页脚首页
export const SgpFooterFull: FC<FooterProps> = (props) => {
  const { locale = 'ZH_CN', showPcgTerm = true } = props;
  const localeWording = locales[locale];

  return <div className='tds-footer-full-sgp'>
    {showPcgTerm ? <div className='footer-pcg-term'>
      <Row gutter={24} align='middle'>
        <Col>
          <img src={TdsQQHomeLogo} alt="" className='tds-footer-full-logo' onClick={() => handleOpenUrl(TDS_QQHOME_URL)} />
        </Col>
        {tdsqqPlatformList.map((platform, idx) => (
          <Col key={idx} onClick={() => handleOpenUrl(platform.src)} className='tds-footer-home-qq'>{platform.title}</Col>
        ))}
      </Row>
    </div> : null}
    <Space size={11} align='center'>
      <span>{localeWording.copyright}</span>
      <span className='footer-pcg-href'>
        <Typography.Link className='footer-pcg-href-link' onClick={() => (handleOpenUrl(props.serviceTermUrl || 'https://www.qq.com/contract.shtml'))}>{localeWording.serviceTerm}</Typography.Link>
        | <Typography.Link  className='footer-pcg-href-link' onClick={() => (handleOpenUrl(props?.privacyPolicyUrl || 'https://privacy.qq.com/policy/tencent-privacypolicy'))}>{localeWording.privacy}</Typography.Link>
        | <Typography.Link  className='footer-pcg-href-link' onClick={() => (handleOpenUrl(props?.cookiePolicyUrl || 'https://privacy.qq.com/policy/tencent-privacypolicy'))}>{localeWording.cookiePolicy}</Typography.Link>
      </span>
    </Space>
  </div>;
};

// 商业化移动端页脚
export const SgpFooterFullMobile: FC<FooterProps> = (props) => {
  const { t } = useTranslation();
  const { icp = DEFAULT_ICP, icpURL = DEFAULT_ICP_URL } = props;

  return (
    <div className='tds-footer-full-mobile'>
      <div className='footer-pcg-term'>
        <img src={TdsQQHomeLogo} className='tds-footer-full-mobile-logo' />
        {tdsqqPlatformList.map((platform, idx) => (
          <a key={idx} href={platform.src} target="_blank" className='platform-title'>{platform.title}</a>
        ))}
      </div>
      <div className='footer-copyright'>
        Copyright © 1998 - 2024 Tencent. All Rights Reserved.
      </div>
      <div className='footer-links'>
        <a href="https://www.qq.com/contract.shtml" target="_blank">{t("服务协议")}</a>
        <a href={props?.privacyPolicyUrl || 'https://privacy.qq.com/policy/tencent-privacypolicy'} target="_blank">{t("服务协议")}</a>
        <span className='footer-ccg'>
          <span>{t("腾讯公司")}<Divider type='vertical' className='divider' />{t("版权所有")}</span>
          <Divider type='vertical' className='divider' />
          <a href={icpURL} target="_blank">
            {t("主体备案号")} {icp}
          </a>
        </span>
      </div>
    </div>
  );
};
